import React, { Component } from 'react';
import $ from 'jquery';
import Form from 'react-jsonschema-form';
import { ListItem, ListItemText, ListItemIcon, Typography, Button ,ListIcon} from '@material-ui/core';
import { Close, AccountCircle, Create } from '@material-ui/icons';

class ComplementaryInfo extends Component{
    state = {
        error: '',
        styleError: {
            color: 'white'
        },

        info: '',
        values: {},
        form: {
            jsonSchema:{
                properties:{}
            },
            uiSchema:{}
        },
        showUpdateForm:"",
        update:false,
    }
    componentDidMount() {
        this.getOtherInfo()
    }
    getOtherInfo() {   
        var methodName = 'Get Other info';
        var idInfo = this.props.boxAssoId;
        // if (idInfo === ''){
        //     idInfo = this.props.boxId;
        // }

        var urlBoxFreeOfAssociation = "/userinfo/info/all?boxAssoId=" + idInfo+"&info=complementary";

        this.serverRequest = $.get(urlBoxFreeOfAssociation, function(result) {
            console.log('[INFO], ', methodName);
            console.log(result);
            let info = '';
            try {
                var data = result; //var data = JSON.parse(result);
                info = data.info;
            } catch (e) {
                // les instructions utilisées pour gérer les exceptions
                console.log('[ERROR], ', methodName, ',Parsing data from serveur ');
                console.log(e); // on transfère l'objet de l'exception à une méthode
                return;
            }
            this.setState({
                info: info,
                values:info
            });
        }.bind(this));
      
    }
    componentWillUnmount() {
        try {} catch (e) {
            console.log(e);
        }
    }
    getSchema= async () => {
        console.log('[INFO] get Schema profile user');
            this.setState({
                update:!this.state.update
            })
            // var idInfo = this.props.userId;
            // if (idInfo === ''){
            //     idInfo = this.props.boxId;
            // }
            try {
                if (this.state.update === false) {
                    const infos = await fetch('/schema/getCustomSchema',{
                        method:'POST',
                        headers: { 
                            'Content-Type': 'application/json',
                            //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                        },
                        body:JSON.stringify({
                            "idSchema":"complementary",
                            "boxAssoId": this.props.boxAssoId
                        }),
                        
                        credentials: 'same-origin',
                    });
                    let body = await infos.json();                

                    // body = body === null ? [] : body
                    this.setState({
                        form:{
                            uiSchema:JSON.parse(body.uiSchema),
                            jsonSchema:JSON.parse(body.jsonSchema),

                        },
                        schemaID:body.schemaID,
                        
                    })
                        
                    console.log("[INFO] get Schema profile user", this.state);  
                }
            } catch (error) {
                console.log("[ERROR] get Schema profile user",error)
                return
            }
    }
    updateInfo(field) {
        console.log('[INFO] get forms profile user');
        
        const values = this.state.values;
        const schema = this.state.form.jsonSchema.properties;
        const ui = this.state.form.uiSchema

        if(values){

            let display = values[field];//copy value prevent changing real value
            let specificSchema = {};//will contain current json schema
            let specificUi = {};//will contain current ui schema
            let formDatas = {};//will contain current Db value to prefill the form

            if(Array.isArray(display)){//if value is array, join values
                display = display.join(", ");
            }

            Object.keys(schema).map((schKey, j) => {//get jsonshcema for each field

                if(schKey == field){
                    specificSchema = {
                        "type":"object",
                        "properties":{
                            [schKey]: schema[schKey]
                        }
                    };//..., properties:{Age:{title: "Age", type: "integer", minimum: 16, maximum: 100}}

                    formDatas = {
                        [field]:values[field]
                    };//{"Age":24} = old/DB value
                }
                return;
            });

            Object.keys(ui).map((uiKey) => {//get uishcema for each field
                if(uiKey == field){
                    specificUi = {
                        [uiKey]:ui[uiKey]
                    };
                    //{Age: { ui: widget:"range"}}
                }
                return;
            });

            return[
                specificSchema,
                specificUi,
                formDatas         
            ]

        }
    }
    handlePreSubmit=  ({formData},item) => {
        console.log("handlePreSubmit" , formData)
        console.log("handlePreSubmit" , item)
        let resp = {};
        resp[item]= formData
        console.log("handlePreSubmit" , resp)
        this.handleSubmit({formData: resp})
    }

    handleSubmit= async ({formData}) => {
        //HERE formData is an attribute from the result object of the form
        console.log("[INFO] SUBMIT",formData);
        try {
            var idInfo = this.props.boxAssoId;
            // if (idInfo === ''){
            //     idInfo = this.props.boxId;
            // }
            const infos = await fetch('/schema/updateUser',{
                method:'POST',
                headers: { 
                    'Content-Type': 'application/json',
                    //'X-CSRF-Token': document.getElementsByName("_csrf")[0].content
                },
                body:JSON.stringify({
                    "data":formData,
                    "boxAssoId": idInfo,
                    "idSchema":"complementary"
                }),
                
                credentials: 'same-origin',
            });
            let body = await infos.json();                
            console.log("[INFO] submit update profile user", body);  
            if(body.errorCode === 200){
                this.setState({
                    showUpdateForm: ""
                })
                this.getOtherInfo()
            }

        } catch (error) {
            console.log("[ERROR] submit update profile user",error)
            return
        }
        
    }
    render() {
        //Prepare request
        console.log('[DEBUG], Complementary USER , info : ', this.state.info);
        console.log('[DEBUG], Complementary USER , question : ', this.state.form);
        let infoOtherTmp = [];
        let infoOtherTmpUpdateEmpty = [];
        let x = '';
        let i=-1
        for ( x in this.state.info){
            i++
            const target = "#collapse"+i;
            infoOtherTmp.push(
                <dl className="dl-horizontal">
                            <dt>{x}</dt>
                    <dd className="row">
                        <div className="col-xs-8">
                            {this.state.info[x]} 
                        </div>   
                        {this.state.update &&
                            <div className="col-xs-4">
                                <a href="#" onClick={()=>this.setState({
                                    showUpdateForm: this.state.showUpdateForm === target ? "" : target
                                    }) }>
                                    {this.state.showUpdateForm !== target &&
                                        <i className="zmdi zmdi-edit" ></i>
                                    }
                                    {this.state.showUpdateForm === target &&
                                        <i className="zmdi zmdi-close" ></i>
                                    }
                                </a>
                            </div>
                        }
                    </dd>
                </dl>
            );
            if(this.state.showUpdateForm === target && this.state.update) {
                const schemas = this.updateInfo(x)
                console.log( schemas);
                infoOtherTmp.push(
                    <dl className="dl-horizontal">
                        <dd>
                            <Form
                                schema={schemas[0]}
                                uiSchema={schemas[1]}
                                formData={schemas[2]}
                                onSubmit={this.handleSubmit}
                            >
                                <Button type="submit" variant="contained" color="primary">
                                    Valider
                                </Button> 
                            </Form>                            
                        </dd>
                    </dl>
                );
            }
        }

        if (this.state.update){
            for ( x in this.state.form.jsonSchema.properties){
                i++
                const target = "#collapse"+i;
                infoOtherTmpUpdateEmpty.push(
                    <dl className="dl-horizontal">
                                <dt>{x}</dt>
                        <dd className="row">
                            <div className="col-xs-8">
                                
                            </div>   
                            {this.state.update &&
                                <div className="col-xs-4">
                                    <a href="#" onClick={()=>this.setState({
                                        showUpdateForm: this.state.showUpdateForm === target ? "" : target
                                        }) }>
                                        {this.state.showUpdateForm !== target &&
                                            <i className="zmdi zmdi-edit" ></i>
                                        }
                                        {this.state.showUpdateForm === target &&
                                            <i className="zmdi zmdi-close" ></i>
                                        }
                                    </a>
                                </div>
                            }
                        </dd>
                    </dl>
                );
                if(this.state.showUpdateForm === target && this.state.update) {
                    const update = this.updateInfo(x)
                    console.log( update);
                    console.log( x);
                    console.log(this.state.form.jsonSchema.properties[x]);
                    console.log(this.state.form.uiSchema[x]);
                    let uiInfo = this.state.form.uiSchema[x];
                    if(typeof uiInfo === 'undefined') {
                        uiInfo = {};
                    }
                    let formDataTmp = "";
                    let jsonSchemaInfoTmp = this.state.form.jsonSchema.properties[x];
                    if(typeof update !== 'undefined') {
                        if (update.length > 1){
                            jsonSchemaInfo= update[0]
                            formDataTmp = update[2]
                        }
                    }
                    var jsonSchemaInfo = jsonSchemaInfoTmp
                    const info = x;
                    console.log(formDataTmp);
                
                    infoOtherTmpUpdateEmpty.push(
                        <dl className="dl-horizontal">
                            <dd>
                                
                                <Form
                                    schema={jsonSchemaInfo}
                                    uiSchema={uiInfo}
                                    formData={formDataTmp}
                                    onChange={(e)=> console.log(e)}
                                    onSubmit={(formData) => this.handlePreSubmit(formData,info)}
                                >
                                    
                                    <Button type="submit" variant="contained" color="primary">
                                        Valider
                                    </Button> 
                                    
                                </Form>
                                    
                            </dd>
                        </dl>
                    );
                }
            }
        }
        return (
            <div>
                { this.state.update &&
                    <div>
                        <ListItem button>
                            <ListItemIcon>
                              
                            </ListItemIcon>
                            <ListItemText><Typography variant="h4">Complementary Info</Typography> </ListItemText>
                            {this.state.update ? 
                                <Close onClick={this.getSchema} /> : 
                                <Create onClick={this.getSchema} />
                            }
                        </ListItem>
                        
                        <div className="pmbb-body p-l-30">
                            <div className="pmbb-view">
                                {infoOtherTmp}
                            </div>

                            <div className="pmbb-edit">
                                {infoOtherTmpUpdateEmpty}
                            </div>
                        </div>

                    </div>
                }
            </div>

        )
    }
};

export default ComplementaryInfo
